export const getHost = () => {
	return window.location.hostname;
};
